module.exports = __webpack_public_path__ + "static/OGWII-main-79b222cbaf4be47dd4c4e38303746f82.jpg";